import { createEntityAdapter, EntityState, EntityAdapter } from '@ngrx/entity';
import { User } from '../../../models/user.model';

import * as userActions from '../actions/users.actions';
import { ActionType } from '../actions/users.actions';

export interface State extends EntityState<User> { fetchRunning: null; addUserStatus: { status: null, id: null }; }

export const userAdapter: EntityAdapter<User> = createEntityAdapter<User>();

export const initialState: State = userAdapter.getInitialState({ fetchRunning: null, addUserStatus: { status: null, id: null } });

export function userReducer(
  state: State = initialState,
  action: userActions.UserActions
) {
  switch (action.type) {

    case ActionType.FETCH_USERS_BY_COMPANYID_SUCCESS:
      return userAdapter.setAll(action.users, {
        ...state,
        fetchRunning: false,
      });

    case ActionType.FETCH_USERS_SUCCESS:
      return userAdapter.setAll(action.user, {
        ...state,
        fetchRunning: false,
      });

    case ActionType.FETCH_USER_SUCCESS:
      userAdapter.removeAll({
        ...state,
        fetchRunning: false,
      });

      return userAdapter.addOne(action.user, {
        ...state,
        fetchRunning: false,
      });

    case ActionType.ADD_USER:
      return {
        ...state,
        fetchRunning: true,
        addUserStatus: { status: false, id: null }
      };
    case ActionType.ADD_USER_SUCCESS:
      return userAdapter.addOne(action.user, {
        ...state,
        fetchRunning: false,
        addUserStatus: { status: true, id: action.user.id }
      });

    case ActionType.ADD_USER_FAILED:
      return {
        ...state,
        fetchRunning: false,
        addUserStatus: { status: false, id: null }
      };

    case ActionType.DELETE_USER:
      return {
        ...state,
        fetchRunning: true,
      };
    case ActionType.DELETE_USER_SUCCESS:
      return userAdapter.removeOne(action.id, {
        ...state,
        fetchRunning: false,
      });

    case ActionType.DELETE_USER_FAILED:
      return {
        ...state,
        fetchRunning: false,
      };
    case ActionType.UPDATE_USER:
      return {
        ...state,
        fetchRunning: true,
      };

    case ActionType.UPDATE_USER_SUCCESS:
      return userAdapter.updateOne({ id: action.id, changes: action.changes, }, {
        ...state,
        fetchRunning: false,
      });

    case ActionType.UPDATE_USER_FAILED:
      return {
        ...state,
        fetchRunning: false,
      };



    //  return userAdapter.addOne(action.payload.user, state);
    // case userActions.TOGGLE_DONE:
    //   return userAdapter.updateOne(
    //     { id: action.payload.id, changes: { done: action.payload.done } },
    //     state
    //   );
    // case userActions.UPDATE_USER:
    //   return userAdapter.updateOne(
    //     { id: action.payload.id, changes: { value: action.payload.newValue } },
    //     state
    //   );
    // case userActions.DELETE_USER:
    // return userAdapter.removeOne(action.payload.id, state);



    default:
      return state;
  }
}

export const getFetchRunning = (state: State) => state.fetchRunning;
export const getUserStatus = (state: State) => state.addUserStatus;
export const getAllOfTheCompanies = ((state: State) => {

  return state.entities;

});

// export const getAllOfTheCompanies =( (state: State) => {

//   let xxx = [];

//   for (const key of Object.keys(state.entities)) {
//     const value = state.entities[key] as User
//     // console.log(`${key} -> ${value}`)
//     // console.log("value", value)

//     xxx.push(value);
//  }

//   return xxx.filter((book: User) => book.id === '3afc1e44-ee49-d1a0-3b41-f4441cd5a8ce');

// });

